module.exports = __webpack_public_path__ + "static/media/transporter-empty.c0debc2d.svg";